import React, { useEffect } from 'react';

import globals from '../../../globals.json';
import Popup from '../../partials/OLIPopup';

const FailureScreen = props => {

    useEffect(() => {
        if(props.data.type !== ''){
            props.audioController.playAudioByName(props.data.type === 'ticket' ? 'siren' : 'crash')
        }
        return () => {
            if(props.data.type !== ''){
                props.audioController.removeAudio(props.data.type === 'ticket' ? 'siren' : 'crash')
            }
        }
    }, [])
    return (
        <div className={`FailureScreen ${props.data.type} ${props.data.class}`}>
            <div className={`top-right-orange`} />
            <div className={`bottom-left-orange`} />
            <div className={`fade-in-container`}>
                {props.data.type === 'ticket' 
                    ? <> 
                        <div className={`ticket`}>
                            <p className={`citation-number`} dangerouslySetInnerHTML={{__html: props.data.ticketContent.citationNumber}} />
                            <p className={`jurisdiction`} dangerouslySetInnerHTML={{__html: props.data.ticketContent.jurisdiction}} />
                            <p className={`dl-number`} dangerouslySetInnerHTML={{__html: props.data.ticketContent.dlNumber}} />
                            <p className={`vehicle-plate`} dangerouslySetInnerHTML={{__html: props.data.ticketContent.vehiclePlate}} />
                            <p className={`at`} dangerouslySetInnerHTML={{__html: props.data.ticketContent.at}} />
                            <p className={`offenses`} dangerouslySetInnerHTML={{__html: props.data.ticketContent.offenses}} />
                            <p className={`statute`} dangerouslySetInnerHTML={{__html: props.data.ticketContent.statute}} />
                            <p className={`description`} dangerouslySetInnerHTML={{__html: props.data.ticketContent.description}} />
                            <p className={`total-fine`} dangerouslySetInnerHTML={{__html: props.data.ticketContent.totalFine}} />
                        </div>
                        <div className={`global-button revisit-orientation-button`} onClick={props.revisitOrientation}>{globals.revisitOrientationButtonText}</div>
                        <div className={`global-button retry-button`} onClick={props.resetCrossing}>{globals.retryButtonText}</div>
                      </>
                    : <Popup data={props.data.popup} onComplete={props.resetCrossing} 
                        additionalButton={props.revisitOrientation ? [
                            <p>If you need help, revisit the Orientation section for key driving tips.</p>,
                            <div className={`global-button revisit-orientation-button`} onClick={props.revisitOrientation}>{globals.revisitOrientationButtonText}</div>
                        ] : undefined} 
                        />
                }        
                <div className={`background`} />
            </div>
        </div>
    )
}

export default FailureScreen